import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { Planogram3d } from "../Planogram3d/Planogram3d";
import { Grid } from "src/elements/Box/Box";
import { Planogram3dPanel } from "../Planogram/components/Planogram3dPanel/Planogram3dPanel";

interface Props {
  pog: Pog;
  setPog: React.Dispatch<React.SetStateAction<Pog>>;
}

export const Planogram3dWithTools = ({ pog, setPog }: Props) => {
  return (
    <Grid width="100%" columns="1fr auto" flexGrow gap="10px" borderRadius="3px" overflow="hidden">
      <Planogram3d pog={pog} />
      <Planogram3dPanel pog={pog} setPog={setPog} />
    </Grid>
  );
};
